var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.oldTokenExist)?_c('a',{staticClass:"float",on:{"click":_vm.backToAdmin}},[_c('i',{staticClass:"fas fa-backward my-float"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }